export default __webpack_public_path__ + "static/media/987.294114ea.png";